function hideRemarkFilters() {
  document.querySelectorAll(".filter-group__heading__text").forEach(function (el) {
    if (el.textContent.trim() === "Remark") {
      const filterGroup = el.closest(".filter-group");
      if (filterGroup) {
        const filterContainer = filterGroup.closest(".filter-container");
        if (filterContainer && filterContainer.getAttribute("data-collection-handle") === "archive") {
          // Do nothing if inside archive collection
          return;
        }
        filterGroup.style.display = "none";
      }
    }
  });
}

window.addEventListener("filters:run", function () {
  hideRemarkFilters();
});
